export enum PaymentModel {
    STANDARD = 'Standard',
    PWYW = 'Pay What You Want',
}